import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getById = createAsyncThunk("rekening/getById",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/rekening/${val}`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const findAll = createAsyncThunk("rekening/findAll",
    async () => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/rekening`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });
export const findDetailAll = createAsyncThunk("rekening/findDetailAll",
    async () => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/rekening/detail`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const removeData = createAsyncThunk("rekening/removeData",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/rekening/${val}`
            const response = await jwtAuthAxios.delete(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const addData = createAsyncThunk("rekening/addData",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/rekening`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const updateData = createAsyncThunk("rekening/updateData",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/rekening`
            const response = await jwtAuthAxios.put(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

const initialState = {
    loading: false,
    rekening:{},
    rekeningList: [],
    rekeningDetailList: [],
}

const rekeningSlice = createSlice({
    name: "rekening",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(findAll.pending, (state) => {
                state.loading = true;
            })
            .addCase(findAll.fulfilled, (state, action) => {
                state.rekeningList = action.payload;
                state.loading = false;
            })
            .addCase(findAll.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(findDetailAll.pending, (state) => {
                state.loading = true;
            })
            .addCase(findDetailAll.fulfilled, (state, action) => {
                state.rekeningDetailList = action.payload;
                state.loading = false;
            })
            .addCase(findDetailAll.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(addData.pending, (state) => {
                state.loading = true;
            })
            .addCase(addData.fulfilled, (state, action) => {
                state.rekening = action.payload;
                state.loading = false;
            })
            .addCase(addData.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(updateData.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateData.fulfilled, (state, action) => {
                state.rekening = action.payload;
                state.loading = false;
            })
            .addCase(updateData.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(getById.pending, (state) => {
                state.loading = true;
            })
            .addCase(getById.fulfilled, (state, action) => {
                state.rekening = action.payload;
                state.loading = false;
            })
            .addCase(getById.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(removeData.pending, (state) => {
                state.loading = true;
            })
            .addCase(removeData.fulfilled, (state, action) => {
                state.rekening = action.payload;
                state.loading = false;
            })
            .addCase(removeData.rejected, (state, action) => {
                state.loading = false;
            })
        ;
    }
})
export const rekeningSelectors = (state) => state.rekening;
export default rekeningSlice.reducer;